module.exports = __webpack_public_path__ + "static/media/realaltena_logo_bco.011adfc2.png";